export default __webpack_public_path__ + "static/media/Hippo CMMS.6c96ba73.png";